<template>
    <div class="main-content-section bg-white pt-5 pb-5">
        <flash-alert :message="flashMessage" v-if="showAlert"></flash-alert>
        <div class="container overflow-hidden">
            <div class="order-main-info-wrapper row d-flex align-items-center pb-3">
                <div class="col-1 d-none d-lg-block">
                    <a v-if="prevUrl && showNextPrev" :href="'/submission/'+prevUrl + '/judging'" class="prev-action-wrapper text-center d-flex flex-column justify-content-center">
                        <caretleft class="margin-auto"></caretleft>
                        <div class="small-uppercase mt-1">Previous</div>
                    </a>
                </div>
                <div class="col-3 position-relative order-show-img">
                    <img :src="order.program_logo_preview" width="200" height="200" class="judgement-image-placement">
                </div>
                <div class="col-7">
                    <h1 class="mb-0 program_title_with_underline">
                        {{ order.program_title }}
                    </h1>
                </div>
                <div class="col-1 d-none d-lg-block">
                    <a v-if="nextUrl && showNextPrev" :href="'/submission/'+nextUrl + '/judging'" class="next-action-wrapper text-center d-flex flex-column justify-content-center">
                        <caretright class="margin-auto">></caretright>
                        <div class="small-uppercase mt-1">Next</div>
                    </a>
                </div>
            </div>
        </div>


        <div class="main-content-section bg-white pt-4" id="top-of-episode-video">
            <div class="container previous-next-show-section">
                <video-episode-viewer :episodes="order.video_file_objects" :episode_to_show="episodeIndex" @episodeUpdated="episodeUpdated"></video-episode-viewer>
                <div class="row">
                    <div class="col-12 offset-md-1">
                        <h5 class="mt-5 mb-2" v-if="((order.video_file_objects) && (order.video_file_objects.length > 1))">More Episodes</h5>

                        <div class="episode-wrapper d-flex flex-wrap" v-if="((order.video_file_objects) && (order.video_file_objects.length > 1))">
                            <div class="episode-item cursor-pointer" v-for="(vfo, index) in order.video_file_objects" @click="episodeChanger(index)">
                                <div class="episode-img-wrapper position-relative">
                                    <div class="episode-playing" v-if="episodeIndex == index">
                                        Now Playing
                                    </div>
                                    <div class="play-icon" v-if="episodeIndex != index">
                                        <play></play>
                                    </div>
                                    <img :src="vfo.thumbnail">
                                </div>
                                <div class="mt-1 episode-title-wrapper accent-color small">
                                    <span v-if="vfo.episode">{{ 'E' + episodeNumberFormat(vfo.episode) + ' - ' }}</span> {{ vfo.episode_title }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container mt-2">
                <div class="row">
                    <div class="col-12 col-md-7 offset-md-1" :class="round == 1 ? 'col-md-7' : 'col-md-11'">
                        <h5 class="mt-3 mb-1">Program Synopsis</h5>
                        <p>{{ order.program_synopsis }}</p>

                        <h5 class="mt-3 mb-1">Issue Covered</h5>
                        <p>{{ order.issue_covered }}</p>

                        <h5 class="mt-3 mb-1">Why were these issues important and compelling enough to be developed into this project?</h5>
                        <p>{{ order.issue_description }}</p>

                        <h5 class="mt-3 mb-1">Network or Platform</h5>
                        <p>{{ order.cable_network }}</p>

                    </div>
                    <div class="col-12 col-md-3" :class="round == 1 ? 'col-md-3' : 'd-none'">
                        <entry-judging-form-scored
                            :submit-score-url="submitScoreUrl"
                            :skip-url="skipUrl"
                            :skips-maximum="skipsMaximum"
                            :skips-remaining="skipsRemaining"
                            @judgingErrorMessage="judgingErrorMessage"
                        >
                        </entry-judging-form-scored>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import caretleft from './icons/caret_left.vue';
    import caretright from './icons/caret_right.vue';
    import play from './icons/play.vue';
    import EntryJudgingFormScored from "./EntryJudgingFormScored.vue";

export default {
    name: "EntryJudgingDetails",
    components: {caretleft, caretright, play, EntryJudgingFormScored},
    props: {
        order: {
            type: Object,
            required: true
        },
        showNextPrev: {
            type: Boolean,
            default: false
        },
        submitScoreUrl: {
            type: String,
            required: true
        },
        skipUrl: {
            type: String,
            required: true
        },
        skipsMaximum: {
            type: String,
            required: true
        },
        skipsRemaining: {
            type: String,
            required: true
        },
        round: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            episodeIndex: 0,
            pluck_ids: [],
            nextUrl: '',
            prevUrl: '',
            flashMessage: '',
            showAlert: false,
        }
    },
    mounted() {
        if(this.showNextPrev && localStorage.getItem('honors-next-prev')) {
            this.pluck_ids = localStorage.getItem('honors-next-prev');
            this.prevNextUrls();
        }
    },
    methods: {
        episodeChanger: function(index) {
            let app = this;
            app.episodeIndex = index;
            VueScrollTo.scrollTo('#top-of-episode-video', 700);
        },
        prevNextUrls: function() {
            let app = this;
            if( app.pluck_ids && app.pluck_ids.length>0 ) {
                let indexList = app.pluck_ids.split(',');
                let currentOrderIndex = indexList.indexOf(app.order.order_id);
                let prev_index = Number(currentOrderIndex) - Number(1);
                let next_index = Number(currentOrderIndex) + Number(1);

                if (prev_index >= 0) {
                    app.prevUrl = indexList[prev_index];
                }

                if (next_index < indexList.length) {
                    app.nextUrl = indexList[next_index];
                }
            }
        },
        episodeNumberFormat: function(episode) {
            if(episode < 10) {
                return '0' + episode;
            }
            return episode;
        },
        judgingErrorMessage: function(message) {
            this.flashMessage = message;
            this.showAlert = true;
            window.scrollTo(0, 0);
        },
        episodeUpdated: function(index) {
            this.episodeIndex = index;
        }
    }
}
</script>
<style lang="scss">
.bmpui-ui-watermark {
    display:none;
}
.bmpui-ui-recommendation-overlay {

}
</style>
